import React, { Component } from "react";
import { Translate, I18n } from "react-redux-i18n";
import { Form } from "react-bootstrap";
import axios, { CancelToken } from "axios";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import { CountryDropdown } from "react-country-region-selector";
import { setAlert } from "../../../actions/alertActions";
import PhoneInput from "react-phone-input-2";
import { selectCountry } from "../../utils/Utils";
import "../../../styles/components/evs/modals/RequestNetworkAccess.scss";

class RequestNetworkAccess extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      identification_name: null,
      identification_nif: null,
      identification_address: null,
      identification_number: null,
      identification_phone: null,
      identification_internationalPrefix: selectCountry(this.props.country),
      identification_zipcode: null,
      identification_country: this.props.country || "",
      identification_city: null,
      identification_state: null,
      correspondency_email: null,
      address_value: "address-other",

      identification_name_touched: false,
      identification_nif_touched: false,
      identification_address_touched: false,
      identification_number_touched: false,
      identification_phone_touched: false,
      identification_zipcode_touched: false,
      identification_city_touched: false,
      identification_state_touched: false,
      correspondency_email_touched: false,

      identification_name_valid: false,
      identification_nif_valid: false,
      identification_address_valid: false,
      identification_number_valid: false,
      identification_phone_valid: false,
      identification_zipcode_valid: false,
      identification_country_valid: false,
      identification_city_valid: false,
      identification_state_valid: false,
      correspondency_email_valid: false,
    };

    this.validateOverallForm = this.validateOverallForm.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
  }

  handleOnChange(reg, e) {
    if (e.target.name === "identification_nif") {
      if (this.isNifValid(e)) {
        this.safeSetState({
          [e.target.name + "_valid"]: true,
          [e.target.name + "_touched"]: true,
        });
      } else {
        this.safeSetState({
          [e.target.name + "_valid"]: false,
          [e.target.name + "_touched"]: true,
        });
      }
    } else {
      if (this.validateFormComponent(e.target.value, reg)) {
        this.safeSetState({
          [e.target.name + "_valid"]: true,
          [e.target.name + "_touched"]: true,
        });
      } else {
        this.safeSetState({
          [e.target.name + "_valid"]: false,
          [e.target.name + "_touched"]: true,
        });
      }
    }

    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  handleOnBlur(e) {
    switch (e.target.name) {
      case "identification_name":
        this.safeSetState({
          identification_name_touched: true,
        });
        break;
      case "identification_nif":
        this.safeSetState({
          identification_nif_touched: true,
        });
        break;
      case "identification_address":
        this.safeSetState({
          identification_address_touched: true,
        });
        break;
      case "identification_number":
        this.safeSetState({
          identification_number_touched: true,
        });
        break;
      case "identification_zipcode":
        this.safeSetState({
          identification_zipcode_touched: true,
        });
        break;
      case "identification_phone":
        this.safeSetState({
          identification_phone_touched: true,
        });
        break;
      case "identification_city":
        this.safeSetState({
          identification_city_touched: true,
        });
        break;
      case "identification_state":
        this.safeSetState({
          identification_state_touched: true,
        });
        break;
      case "correspondency_email":
        this.safeSetState({
          correspondency_email_touched: true,
        });
        break;
      default:
        break;
    }
  }

  handlePhoneChange(reg, phone, obj) {
    const e = phone.replace(/[^0-9]+/g, "").slice(obj.dialCode.length);

    this.safeSetState(
      {
        identification_internationalPrefix: obj.dialCode,
        identification_phone: e,
      },
      () => {
        if (this.validateFormComponent(e, reg)) {
          this.safeSetState({
            identification_phone_valid: true,
            identification_phone_touched: true,
          });
        } else {
          this.safeSetState({
            identification_phone_valid: false,
            identification_phone_touched: true,
          });
        }
      }
    );
  }

  validateOverallForm(callback) {
    let newObj = this.state;
    delete newObj.identification_number;
    delete newObj.identification_number_valid;
    delete newObj.identification_number_touched;
    delete newObj.identification_state;
    delete newObj.identification_state_valid;
    delete newObj.identification_state_touched;
    delete newObj.form_valid;

    if (
      Object.values(newObj).every((x) => x !== null && x !== "" && x !== false)
    ) {
      this.safeSetState(
        {
          form_valid: true,
        },
        callback
      );
    } else {
      this.safeSetState(
        {
          form_valid: false,
        },
        callback
      );
    }
  }

  handleOnSubmit(e) {
    e.preventDefault();

    const submition = () => {
      if (this.state.form_valid) {
        this.submitRequest();
      } else {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyForm_alert"),
          "danger"
        );
      }
    };

    this.validateOverallForm(submition);
  }

  validateFormComponent(value, reg) {
    if (value.match(reg)) {
      return true;
    } else {
      return false;
    }
  }

  handleChangeSelect(e) {
    e.preventDefault();

    this.safeSetState({
      address_value: e.target.value,
    });

    if (e.target.value !== "address-other") {
      this.safeSetState({
        identification_address:
          e.target.value === "address-0"
            ? this.props.accountData?.places[0]?.address.street
            : e.target.value === "address-1"
            ? this.props.accountData?.places[1]?.address.street
            : this.props.accountData?.billingAddress?.address,
        identification_city:
          e.target.value === "address-0"
            ? this.props.accountData?.places[0]?.address.city
            : e.target.value === "address-1"
            ? this.props.accountData?.places[1]?.address.city
            : this.props.accountData?.billingAddress?.city,
        identification_zipcode:
          e.target.value === "address-0"
            ? this.props.accountData?.places[0]?.address.zipCode
            : e.target.value === "address-1"
            ? this.props.accountData?.places[1]?.address.zipCode
            : this.props.accountData?.billingAddress?.postCode,
        identification_country:
          e.target.value === "address-0"
            ? this.props.accountData?.places[0]?.address.country
            : e.target.value === "address-1"
            ? this.props.accountData?.places[1]?.address.country
            : this.props.accountData?.billingAddress?.country,
        identification_number:
          e.target.value === "address-0"
            ? this.props.accountData?.places[0]?.address.number
            : e.target.value === "address-1"
            ? this.props.accountData?.places[1]?.address.number
            : this.props.accountData?.billingAddress?.number,
        identification_state:
          e.target.value === "address-0"
            ? this.props.accountData?.places[0]?.address.state
            : e.target.value === "address-1"
            ? this.props.accountData?.places[1]?.address.state
            : this.props.accountData?.billingAddress?.state,

        identification_address_valid: true,
        identification_city_valid: true,
        identification_zipcode_valid: true,
        identification_country_valid: true,
        identification_number_valid: true,
        identification_state_valid: true,

        identification_address_touched: true,
        identification_number_touched: true,
        identification_zipcode_touched: true,
        identification_city_touched: true,
        identification_state_touched: true,
      });
    } else {
      this.safeSetState({
        identification_address: "",
        identification_city: "",
        identification_zipcode: "",
        identification_number: "",
        identification_status: "",
        identification_country: this.props.country || "",

        identification_address_valid: false,
        identification_city_valid: false,
        identification_zipcode_valid: false,
        identification_country_valid: false,
        identification_number_valid: false,
        identification_state_valid: false,

        identification_address_touched: false,
        identification_number_touched: false,
        identification_zipcode_touched: false,
        identification_city_touched: false,
        identification_state_touched: false,
      });
    }
  }

  submitRequest() {
    axios
      .post(
        "/api/private/contracts/activeMobiENetwork",
        {
          contractId: this.props.selectedEV
            ? this.props.selectedEV.contract._id
            : this.props.selectedContract._id,
          name: this.state.identification_name,
          address: {
            street: this.state.identification_address,
            number: this.state.identification_number,
            zipCode: this.state.identification_zipcode,
            country: this.state.identification_country,
            city: this.state.identification_city,
            state: this.state.identification_state,
          },
          nif: this.state.identification_nif,
          mobile: this.state.identification_phone,
          internationalPrefix:
            "+" + this.state.identification_internationalPrefix,
          email: this.state.correspondency_email,
          paymentMethod: "8316124663994904",
        },
        {
          cancelToken: new CancelToken((c) => (this.cancel = c)),
        }
      )
      .then((response) => {
        if (response.status === 200) {
          this.props.setAlert(
            I18n.t("backOffice_network_request_success_alert"),
            "primary"
          );
          this.props.fetchFleets();
          this.props.onHide();
        }
      })
      .catch((err) => {
        console.log("axios", err);
        this.props.setAlert("Error", "danger");
      });
  }

  isNifValid(e) {
    const nif = e.target.value;

    if (nif === null) {
      return false;
    }

    if (!nif.match(/^[0-9]{9}$/)) {
      return false;
    }

    /*
      Function that checks if a nif is valid according to the portuguese fiscal law.
    */
    if (
      nif.substring(0, 1) === "1" ||
      nif.substring(0, 1) === "2" ||
      nif.substring(0, 1) === "3" ||
      nif.substring(0, 2) === "45" ||
      nif.substring(0, 1) === "5" ||
      nif.substring(0, 1) === "6" ||
      nif.substring(0, 2) === "70" ||
      nif.substring(0, 2) === "71" ||
      nif.substring(0, 2) === "72" ||
      nif.substring(0, 2) === "74" ||
      nif.substring(0, 2) === "75" ||
      nif.substring(0, 2) === "77" ||
      nif.substring(0, 2) === "78" ||
      nif.substring(0, 2) === "79" ||
      nif.substring(0, 1) === "8" ||
      nif.substring(0, 2) === "90" ||
      nif.substring(0, 2) === "91" ||
      nif.substring(0, 2) === "98" ||
      nif.substring(0, 2) === "99"
    ) {
      const nifDigits = nif.split("");
      const module11 =
        (parseInt(nifDigits[7]) * 2 +
          parseInt(nifDigits[6]) * 3 +
          parseInt(nifDigits[5]) * 4 +
          parseInt(nifDigits[4]) * 5 +
          parseInt(nifDigits[3]) * 6 +
          parseInt(nifDigits[2]) * 7 +
          parseInt(nifDigits[1]) * 8 +
          parseInt(nifDigits[0]) * 9) %
        11;
      let checkDigit;

      if (module11 === 0 || module11 === 1) {
        checkDigit = 0;
      } else {
        checkDigit = 11 - module11;
      }

      if (checkDigit === parseInt(nifDigits[8])) {
        return true;
      }
    }

    return false;
  }

  componentDidMount() {
    this._mounted = true;

    if (this.state.identification_country !== null) {
      this.safeSetState({
        identification_country_valid: true,
      });
    } else {
      this.safeSetState({
        identification_country_valid: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  resetState() {
    this.safeSetState({
      identification_name: null,
      identification_nif: null,
      identification_address: null,
      identification_number: null,
      identification_phone: null,
      identification_internationalPrefix: selectCountry(this.props.country),
      identification_zipcode: null,
      identification_country: this.props.country || "",
      identification_city: null,
      identification_state: null,
      correspondency_email: null,
      address_value: "address-other",

      identification_name_valid: false,
      identification_nif_valid: false,
      identification_address_valid: false,
      identification_number_valid: false,
      identification_phone_valid: false,
      identification_zipcode_valid: false,
      identification_country_valid: false,
      identification_city_valid: false,
      identification_state_valid: false,
      correspondency_email_valid: false,

      identification_name_touched: false,
      identification_nif_touched: false,
      identification_address_touched: false,
      identification_number_touched: false,
      identification_phone_touched: false,
      identification_zipcode_touched: false,
      identification_city_touched: false,
      identification_state_touched: false,
      correspondency_email_touched: false,

      form_valid: false,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="requestNetworkAccess"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState.bind(this)}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate value="backOffice_network_client_id" />
          </Modal.Title>
        </Modal.Header>
        <div className="evio-card-container">
          <div
            className="evio-card"
            style={{
              ...(this.props.brand &&
                this.props.brand.brandName !== "EVIO" && {
                  backgroundImage: `url('${
                    this.props.brand.icons?.cards?.big ?? ""
                  }')`,
                }),
            }}
          >
            {this.props.selectedContract && (
              <span>
                <p>{this.props.selectedContract.name}</p>
                <p>{this.props.selectedContract.cardName}</p>
              </span>
            )}

            {this.props.selectedEV && (
              <span>
                <p>{this.props.selectedEV.contract.name}</p>
                <p>{this.props.selectedEV.contract.cardName}</p>
              </span>
            )}
          </div>
        </div>

        <Modal.Body>
          <div id="join">
            <Form
              id="requestNetworkAccess-form"
              onSubmit={this.handleOnSubmit.bind(this)}
            >
              <div className="content-section">
                <div className="content">
                  <div className="item">
                    <div className="f-field">
                      <div className="label">
                        <Translate value="backOffice_network_forms_name" />
                      </div>
                      <Form.Control
                        required
                        name="identification_name"
                        isValid={this.state.identification_name_valid}
                        onChange={this.handleOnChange.bind(this, /.+\D\S/)}
                        onBlur={this.handleOnBlur}
                        type="text"
                      />
                      {!this.state.identification_name_valid &&
                        this.state.identification_name_touched && (
                          <p className="error-text">
                            <Translate value="backOffice_network_forms_invalid_name" />
                          </p>
                        )}
                    </div>

                    <div className="f-field">
                      <div className="label">NIPC/NIF</div>
                      <Form.Control
                        required
                        isValid={this.state.identification_nif_valid}
                        name="identification_nif"
                        onChange={this.handleOnChange.bind(this, /.+\S/)}
                        onBlur={this.handleOnBlur}
                        type="text"
                      />
                      {!this.state.identification_nif_valid &&
                        this.state.identification_nif_touched && (
                          <p className="error-text">
                            <Translate value="backOffice_network_forms_invalid_nif" />
                          </p>
                        )}
                    </div>

                    <div className="break" />

                    {((this.props.accountData.places &&
                      this.props.accountData?.places[0]?.address.street) ||
                      this.props.accountData?.billingAddress?.address) && (
                      <div className="f-field">
                        <div className="label">
                          <Translate value="backOffice_network_forms_contractSelectAddress" />
                        </div>
                        <div className="select-container">
                          <select
                            onChange={(e) => this.handleChangeSelect(e)}
                            value={this.state.address_value}
                          >
                            <option value="address-other">
                              {I18n.t(
                                "backOffice_network_forms_contractOtherAddress"
                              )}
                            </option>
                            {(this.props.accountData?.places[0]?.address
                              .street ||
                              this.props.accountData?.places[1]?.address
                                .street) &&
                              this.props.accountData?.places?.map(
                                (item, index) =>
                                  item.address.street !== "" && (
                                    <option
                                      key={index}
                                      value={`address-${index}`}
                                    >
                                      {item.address.street}
                                    </option>
                                  )
                              )}
                            {this.props.accountData?.billingAddress
                              ?.address && (
                              <option value="address-billing">
                                {
                                  this.props.accountData?.billingAddress
                                    ?.address
                                }
                              </option>
                            )}
                          </select>
                        </div>
                      </div>
                    )}

                    <div className="f-field">
                      <div className="label">
                        <Translate value="backOffice_network_forms_address" />
                      </div>
                      <Form.Control
                        required
                        name="identification_address"
                        value={this.state.identification_address}
                        onChange={this.handleOnChange.bind(this, /.*/)}
                        isValid={this.state.identification_address_valid}
                        onBlur={this.handleOnBlur}
                        type="text"
                        disabled={
                          ((this.props.accountData.places &&
                            this.props.accountData?.places[0]?.address
                              .street) ||
                            this.props.accountData?.billingAddress?.address) &&
                          this.state.address_value !== "address-other" &&
                          "disabled"
                        }
                      />
                      {!this.state.identification_address_valid &&
                        this.state.identification_address_touched && (
                          <p className="error-text">
                            <Translate value="backOffice_network_forms_invalid_address" />
                          </p>
                        )}
                    </div>

                    <div className="break" />

                    <div className="f-field">
                      <div className="label">
                        <Translate value="addAddress_number" />
                      </div>
                      <Form.Control
                        required
                        name="identification_number"
                        value={this.state.identification_number}
                        onChange={this.handleOnChange.bind(this, /^[0-9]*$/)}
                        isValid={this.state.identification_number_valid}
                        onBlur={this.handleOnBlur}
                        type="number"
                        disabled={
                          ((this.props.accountData.places &&
                            this.props.accountData?.places[0]?.address
                              .street) ||
                            this.props.accountData?.billingAddress?.address) &&
                          this.state.address_value !== "address-other" &&
                          "disabled"
                        }
                      />
                      {!this.state.identification_number_valid &&
                        this.state.identification_number_touched && (
                          <p className="error-text">
                            <Translate value="backOffice_network_forms_invalid_number" />
                          </p>
                        )}
                    </div>

                    <div className="f-field">
                      <div className="label">
                        <Translate value="backOffice_network_forms_zipCode" />
                      </div>
                      <Form.Control
                        required
                        name="identification_zipcode"
                        value={this.state.identification_zipcode}
                        isValid={this.state.identification_zipcode_valid}
                        onChange={this.handleOnChange.bind(
                          this,
                          /[1-9][0-9]{3}-[0-9]{3}/
                        )}
                        onBlur={this.handleOnBlur}
                        type="text"
                        disabled={
                          ((this.props.accountData.places &&
                            this.props.accountData?.places[0]?.address
                              .street) ||
                            this.props.accountData?.billingAddress?.address) &&
                          this.state.address_value !== "address-other" &&
                          "disabled"
                        }
                      />
                      {!this.state.identification_zipcode_valid &&
                        this.state.identification_zipcode_touched && (
                          <p className="error-text">
                            <Translate value="backOffice_network_forms_invalid_zipCode" />
                          </p>
                        )}
                    </div>

                    <div className="break" />

                    <div className="f-field">
                      <div className="label">
                        <Translate value="backOffice_network_forms_phoneInput" />
                      </div>
                      <Form.Group className="form-field" controlId="username">
                        <Form.Control
                          as={PhoneInput}
                          tabIndex="1"
                          placeholder=""
                          autoFormat={false}
                          country={
                            this.state.identification_internationalPrefix
                          }
                          countryCodeEditable={false}
                          inputProps={{
                            name: "identification_phone",
                            required: true,
                            autoFocus: true,
                            tabIndex: 2,
                          }}
                          isValid={this.state.identification_phone_valid}
                          onChange={this.handlePhoneChange.bind(
                            this,
                            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/
                          )}
                          onBlur={this.handleOnBlur}
                          required
                        />
                      </Form.Group>
                      {!this.state.identification_phone_valid &&
                        this.state.identification_phone_touched && (
                          <p className="error-text">
                            <Translate value="backOffice_network_forms_invalid_phone" />
                          </p>
                        )}
                    </div>

                    <div className="f-field">
                      <div className="label">
                        <Translate value="backOffice_network_forms_country" />
                      </div>
                      <div className="select-container">
                        <Form.Control
                          as={CountryDropdown}
                          value={this.state.identification_country}
                          onChange={(identification_country) =>
                            this.safeSetState({ identification_country })
                          }
                          disabled={
                            ((this.props.accountData.places &&
                              this.props.accountData?.places[0]?.address
                                .street) ||
                              this.props.accountData?.billingAddress
                                ?.address) &&
                            this.state.address_value !== "address-other" &&
                            "disabled"
                          }
                        />
                      </div>
                    </div>

                    <div className="break" />

                    <div className="f-field">
                      <div className="label">
                        <Translate value="backOffice_network_forms_contractStateAddress" />
                      </div>
                      <Form.Control
                        required
                        name="identification_state"
                        value={this.state.identification_state}
                        onChange={this.handleOnChange.bind(this, /.*/)}
                        isValid={this.state.identification_state_valid}
                        onBlur={this.handleOnBlur}
                        type="text"
                        disabled={
                          ((this.props.accountData.places &&
                            this.props.accountData?.places[0]?.address
                              .street) ||
                            this.props.accountData?.billingAddress?.address) &&
                          this.state.address_value !== "address-other" &&
                          "disabled"
                        }
                      />
                      {!this.state.identification_state_valid &&
                        this.state.identification_state_touched && (
                          <p className="error-text">
                            <Translate value="backOffice_network_forms_invalid_state" />
                          </p>
                        )}
                    </div>

                    <div className="f-field">
                      <div className="label">
                        <Translate value="addAddress_city" />
                      </div>
                      <Form.Control
                        required
                        name="identification_city"
                        value={this.state.identification_city}
                        onChange={this.handleOnChange.bind(this, /.*/)}
                        isValid={this.state.identification_city_valid}
                        onBlur={this.handleOnBlur}
                        type="text"
                        disabled={
                          ((this.props.accountData.places &&
                            this.props.accountData?.places[0]?.address
                              .street) ||
                            this.props.accountData?.billingAddress?.address) &&
                          this.state.address_value !== "address-other" &&
                          "disabled"
                        }
                      />
                      {!this.state.identification_city_valid &&
                        this.state.identification_city_touched && (
                          <p className="error-text">
                            <Translate value="addAddress_cityRequired" />
                          </p>
                        )}
                    </div>

                    <div className="break" />

                    <div className="f-field">
                      <div className="label">Email</div>
                      <Form.Control
                        required
                        title="Utilize um endereço de e-mail válido!"
                        name="correspondency_email"
                        isValid={this.state.correspondency_email_valid}
                        onChange={this.handleOnChange.bind(
                          this,
                          /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/
                        )}
                        onBlur={this.handleOnBlur}
                        type="email"
                      />
                      {!this.state.correspondency_email_valid &&
                        this.state.correspondency_email_touched && (
                          <p className="error-text">
                            <Translate value="backOffice_network_forms_invalid_email" />
                          </p>
                        )}
                    </div>
                  </div>

                  <div className="item bottom">
                    <button type="submit" form="requestNetworkAccess-form">
                      <Translate value="backOffice_network_forms_submit_bt" />
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  country: state.account.accountData.country,
  accountData: state.account.accountData,
});

export default connect(mapStateToProps, { setAlert })(RequestNetworkAccess);
